<div class="alert-wrapper background-color-white">  
  <div class="container-close">
    <button class="close-button" (click)="cancelButton()">X</button>
</div>
  <card-personal-data-protection-policy-form (policyAccepted)="handleAcceptedPolicy($event)"
    class="cs-documents--policy-form justify-center"></card-personal-data-protection-policy-form>
</div>